import Store from '@/store'

export class UsersBackendUtils {

    static fetchUser(uuid) {
        return Store.dispatch("users-backend/fetchUser", uuid);
    }

    static fetchUsersSnapshots() {
        return Store.dispatch("users-backend/fetchUsersSnapshots");
    }

    static fetchSnapFolders() {
        return Store.dispatch("users-backend/fetchSnapFolders");
    }

    static fetchUserSave(uuid) {
        return Store.dispatch("users-backend/fetchUserSave", uuid);
    }

    static createUserSnapshot(data) {
        return Store.dispatch("users-backend/createUserSnapshot",data );
    }

    static updateSnapshotInfo(data) {
        return Store.dispatch("users-backend/updateSnapshotInfo",data );
    }

    static createSnapFolder(data) {
        return Store.dispatch("users-backend/createSnapFolder",data );
    }

    static deleteUserSnapshots(ids) {
        return Store.dispatch("users-backend/deleteUserSnapshots",ids );
    }

    static setAudience(uid, aud) {
        return Store.dispatch("users-backend/setAudience",{uid, aud} );
    }

    static getUser() {
        return Store.getters["users-backend/getUser"];
    }

    static getFolders() {
        return Store.getters["users-backend/getFolders"];
    }

    static getSnapshots() {
        return Store.getters["users-backend/getSnapshots"];
    }

    static removeSnapFolder(fid) {
        return Store.dispatch("users-backend/removeSnapFolder",fid );
    }

    static setSnapshotFolderName(data) {
        return Store.dispatch("users-backend/setSnapshotFolderName",data );
    }

    static moveSnapshotToFolder(data) {
        return Store.dispatch("users-backend/moveSnapshotToFolder",data );
    }

}